module.exports = __webpack_public_path__ + "static/media/social-activities.31ed969f.svg";